module.exports = __webpack_public_path__ + "img/img1_m.76f99b69.png";